import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { HeroComponent } from './hero.component';

@NgModule({
  imports: [
    CommonModule,
    
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    HeroComponent
  ],
  providers: [
  ],
  declarations: [
    HeroComponent
  ]
})
export class HeroModule { }
